module.exports = __webpack_public_path__ + "static/media/icing-green.028d15b5.png";